import { type Icon } from "@tabler/icons-react"
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import { Link, useLocation } from "react-router-dom"
import clsx from "clsx"

export function NavMain({
  items,
}: {
  items: {
    title: string
    url: string
    icon?: Icon
    hasAccess: boolean
  }[]
}) {
  const location = useLocation();
  const pathname = location.pathname;
  return (
    <SidebarGroup>
      <SidebarGroupContent className="flex flex-col gap-2">
        <SidebarMenu>
          {items.filter((item) => item.hasAccess).map((item) => {
            const isActive = pathname === item.url || pathname.startsWith(item.url + "/")
            return (<SidebarMenuItem key={item.title}>
              <SidebarMenuButton tooltip={item.title} className={clsx(
                    "transition-colors",
                    isActive
                      ? "bg-accent text-primary font-semibold"
                      : "hover:bg-accent"
                  )}>
                <Link to={item.url} className="flex items-center gap-2">
                  {item.icon && <item.icon />}
                  <span>{item.title}</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>)
          })}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  )
}
